<!-- Страница каталога интеграций. -->
<template>
  <div>
    <BaseNav title="Интеграции" show-back back-fallback="Home" />
    <IntegrationCatalog />
  </div>
</template>

<script>
import IntegrationCatalog from "@/components/Integration/Catalog.vue";

export default {
  name: "IntegrationsPage",

  components: {
    IntegrationCatalog,
  },
};
</script>
